import { useDaumPostcodePopup } from "react-daum-postcode";
import { OutlinedBlackButton } from "./OutlinedBlackButton";

interface Props {
  disabled?: boolean;
  setAddress: (address: string) => void;
}

const CURRENT_URL =
  "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

export const PostCodeButton: React.FC<Props> = ({ disabled, setAddress }) => {
  const open = useDaumPostcodePopup(CURRENT_URL);

  const handleClickButton = () => {
    open({ onComplete: handleComplete });
  };

  const handleComplete = (data: any) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }
    setAddress(fullAddress);
  };
  return (
    <OutlinedBlackButton
      width="5.438rem"
      height="2.625rem"
      text={"장소 검색"}
      onClick={handleClickButton}
      disabled={disabled}
    />
  );
};
